import { forwardRef, ImgHTMLAttributes } from 'react';

type RedesignImageProps = ImgHTMLAttributes<HTMLImageElement> & {
  priority?: boolean;
};

// Native lazy loading leaves images near the viewport eligible together: no
// image waits for another image's onLoad callback. Critical visuals stay eager.
const RedesignImage = forwardRef<HTMLImageElement, RedesignImageProps>(
  ({ priority = false, loading = 'lazy', decoding = 'async', alt = '', ...props }, ref) => (
    <img
      {...props}
      alt={alt}
      ref={ref}
      loading={priority ? 'eager' : loading}
      decoding={decoding}
    />
  )
);

RedesignImage.displayName = 'RedesignImage';

export default RedesignImage;
